import { CaretLeft } from "@phosphor-icons/react";

export function Numpad({ onKeyPress, onDelete, onSubmit, isLoading }) {
  const buttons = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0"];

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <div style={{
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '8px',
      justifyItems: 'center'
    }}>
      {buttons.map((char, idx) => (
        <button
          key={idx}
          type="button"
          onClick={() => onKeyPress(char)}
          className="numpad-btn border-white/80 border-3"
          style={{ fontWeight: 'bold', fontSize: '20px' }}
          disabled={!char || isLoading}
        >
          {char}
        </button>
      ))}
      <button type="button" onClick={onDelete} disabled={isLoading} className="numpad-btn border-white/80 border-3">
        <CaretLeft size={20} weight="bold" style={{ margin: '0 auto' }} />
      </button>
      <button
        type="button"
        onClick={handleSubmit}
        disabled={isLoading}
        style={{
          gridColumn: 'span 3',
          marginTop: '16px',
          width: '100%',
          maxWidth: '240px',
          height: '60px',
          backgroundColor: '#16a34a',
          color: 'white',
          borderRadius: '12px',
          border: '3px solid #ffffffff',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '18px',
          transition: 'all 0.2s',
          opacity: isLoading ? 0.5 : 1
        }}
        onMouseEnter={(e) => !isLoading && (e.target.style.backgroundColor = '#15803d')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#16a34a')}
      >
        {isLoading ? "Loading..." : "Pay"}
      </button>
    </div>
  );
}
